import { classNames } from "@/utils/classnames";
import { Switch } from "@headlessui/react";

export const ToggleSizes = ["xs", "sm", "md", "lg"] as const;
export type ToggleSize = (typeof ToggleSizes)[number];

const sizeClasses: Record<ToggleSize, string> = {
  xs: "h-4 w-9",
  sm: "h-5 w-10",
  md: "h-6 w-11",
  lg: "h-8 w-14",
};
const buttonSizeClasses: Record<ToggleSize, string> = {
  xs: "h-3 w-3",
  sm: "h-[14px] w-[14px]",
  md: "h-5 w-5",
  lg: "h-6 w-6",
};
// Travel distance equals the pill's inner width (width minus the 2px border on
// each side) minus the circle's width, so the circle lands flush at each end.
const translateClasses: Record<ToggleSize, string> = {
  xs: "translate-x-5",
  sm: "translate-x-[22px]",
  md: "translate-x-5",
  lg: "translate-x-7",
};

export interface ToggleProps {
  checked?: boolean;
  onChange?: (newValue: boolean) => void;
  disabled?: boolean;
  size?: ToggleSize;
  name?: string;
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled,
  name,
  size = "md",
}) => {
  return (
    <Switch
      checked={!!checked}
      onChange={() => onChange && onChange(!checked)}
      className={classNames(
        checked ? "bg-cds-bright-green-600" : "bg-gray-200",
        "relative flex flex-shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-cds-bright-green-500 focus:ring-offset-2",
        disabled ? "opacity-50 pointer-events-none focus:ring-0" : null,
        sizeClasses[size],
      )}
      name={name}
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className={classNames(
          checked ? translateClasses[size] : "translate-x-0",
          "pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
          buttonSizeClasses[size],
        )}
      />
    </Switch>
  );
};
